// Mock data for Zentiam website

export const mockServices = [
  {
    id: 1,
    title: 'AI Strategy Consulting',
    description: 'Identify high-impact opportunities to integrate AI into your business model.',
    icon: 'Brain',
    color: 'purple',
    details: 'Work with our AI strategists to develop a comprehensive roadmap for AI adoption tailored to your organization.'
  },
  {
    id: 2,
    title: 'Custom AI Solutions',
    description: 'Build intelligent systems tailored to your workflows.',
    icon: 'Cpu',
    color: 'blue',
    details: 'From concept to deployment, we design and build custom AI solutions that solve your specific business challenges.'
  },
  {
    id: 3,
    title: 'Automation & Integration',
    description: 'Automate repetitive tasks and optimize operations.',
    icon: 'Zap',
    color: 'orange',
    details: 'Streamline your operations with intelligent automation that reduces costs and improves efficiency.'
  },
  {
    id: 4,
    title: 'Training & Enablement',
    description: 'Empower your teams to work confidently with AI.',
    icon: 'GraduationCap',
    color: 'green',
    details: 'Comprehensive training programs to help your team leverage AI tools and understand AI capabilities.'
  }
];

export const mockProducts = [
  {
    id: 1,
    title: 'Customer Intelligence Platform',
    description: 'AI-powered customer insights and predictive analytics for enhanced decision-making.',
    features: ['Real-time analytics', 'Predictive modeling', 'Custom dashboards'],
    status: 'Available'
  },
  {
    id: 2,
    title: 'Process Automation Suite',
    description: 'End-to-end workflow automation for operational excellence.',
    features: ['Workflow builder', 'Integration hub', 'Performance monitoring'],
    status: 'Available'
  },
  {
    id: 3,
    title: 'AI Assistant Framework',
    description: 'Build and deploy custom AI assistants for your specific use cases.',
    features: ['Natural language processing', 'Multi-channel support', 'Learning capabilities'],
    status: 'Coming Soon'
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: 'Sarah Chen',
    role: 'CEO, TechFlow Inc',
    quote: 'Zentiam transformed our customer service operations with intelligent automation. ROI achieved in just 6 months.',
    company: 'TechFlow Inc'
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    role: 'CTO, DataSync Solutions',
    quote: 'The AI strategy consulting helped us identify opportunities we never knew existed. Game-changing partnership.',
    company: 'DataSync Solutions'
  },
  {
    id: 3,
    name: 'Emily Watson',
    role: 'Director of Innovation, GlobalRetail',
    quote: 'Working with Zentiam Labs gave us the competitive edge we needed in the AI-driven marketplace.',
    company: 'GlobalRetail'
  }
];

export const mockFAQs = [
  {
    id: 1,
    question: 'What industries do you serve?',
    answer: 'We work with organizations across various industries including technology, finance, healthcare, retail, and manufacturing. Our solutions are tailored to meet specific industry requirements and compliance standards.'
  },
  {
    id: 2,
    question: 'How long does a typical AI implementation take?',
    answer: 'Implementation timelines vary based on project scope. Strategy consulting engagements typically run 4-8 weeks, while custom AI solutions can range from 3-6 months. We work in agile sprints to deliver value incrementally.'
  },
  {
    id: 3,
    question: 'Do you provide ongoing support after implementation?',
    answer: 'Yes, we offer comprehensive support and maintenance packages. This includes system monitoring, performance optimization, updates, and continued training for your team.'
  },
  {
    id: 4,
    question: 'What makes Zentiam different from other AI consultancies?',
    answer: 'We combine strategic consulting depth with technical precision. Our team includes both experienced consultants who understand business transformation and engineers who build production-grade systems. Plus, we develop our own AI products, keeping us at the cutting edge.'
  }
];

export const mockStats = [
  { label: 'Client Success Rate', value: '98%' },
  { label: 'AI Projects Delivered', value: '150+' },
  { label: 'Industries Served', value: '12' },
  { label: 'Average ROI', value: '340%' }
];

export const mockBlogPosts = [
  {
    id: 1,
    title: 'The Future of AI in Enterprise Operations',
    excerpt: 'How leading organizations are leveraging AI to transform their operations and stay competitive.',
    date: '2025-01-15',
    readTime: '5 min read',
    category: 'Strategy'
  },
  {
    id: 2,
    title: 'Building Trust in AI Systems',
    excerpt: 'Best practices for implementing transparent and ethical AI solutions in your organization.',
    date: '2025-01-10',
    readTime: '7 min read',
    category: 'Best Practices'
  },
  {
    id: 3,
    title: 'AI Automation ROI Calculator',
    excerpt: 'How to measure the real impact of AI automation on your bottom line.',
    date: '2025-01-05',
    readTime: '4 min read',
    category: 'Resources'
  }
];
